/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('UserElearningCtrl', function(
    $scope,
    $location,
    $anchorScroll,
    ErrorHandler,
    Search,
    Activity,
    identity,
    user,
    terms,
    modules,
    Log
) {
    $scope.is_me           = user.login === identity.login;
    $scope.student         = user;
    $scope.terms           = terms;
    $scope.selected_module = null;
    $scope.current_date    = moment().format('YYYY-MM-DD HH:mm:ss');
    $scope.average         = 0;
    $scope.modules         = modules;

    const initModulesBySpe = function() {
        $scope.modules_by_spe = { };
        for (let module of Array.from($scope.modules)) {
            const spe = module.uv_name.substr(0, 3);

            if ($scope.modules_by_spe[spe] == null) { $scope.modules_by_spe[spe] = []; }
            $scope.modules_by_spe[spe].push(module);
        }
        // On utilise !! pour être sur que la variable soit un booléen
        return $scope.modules_by_spe_filled = !!(Object.keys($scope.modules_by_spe).length);
    };

    const studentAverage = function(activities) {
        let nb    = 0;
        let total = 0;
        for (let activity of Array.from(activities)) {
            if (('cours' !== activity.type) && (activity.student_mark != null)) {
                nb += activity.coefficient;
                if ((-21 !== activity.student_mark) && (-42 !== activity.student_mark)) {
                    total += activity.student_mark * activity.coefficient;
                }
            }
        }

        return total / nb;
    };

    $scope.getActivities = module => Activity
    .getActivities({
        session_id: module.id})
    .$promise
    .then(function(activities) {
        $scope.average         = 1 === module.published ? studentAverage(activities) : null;
        $scope.selected_module = module;
        $scope.uv_name         = module.uv_name;
        if ('' !== module.long_name) { $scope.uv_name        += ' - ' + module.long_name; }
        $scope.activities      = activities;
        const params                 = { id: module.id };
        if ($location.search().term_id) { params.term_id         = $location.search().term_id; }
        $scope.params          = { module_id: module.id };
        $scope.counter         = {
            cours:      activities.filter(activity => ['cours', 'resource'].includes(activity.type)).length,
            activities: activities.filter(activity => !['cours', 'resource'].includes(activity.type)).length
        };
        $location.search(params);
        $location.hash('uv_info');
        $anchorScroll();
        return getModuleDuration();}).catch(ErrorHandler)
    .finally(function() {
        const log_done = $scope.logs[module.uv_name];
        if (log_done != null) {
            const duration             = moment.duration(log_done * 1000);
            return $scope.logs_duration = Math.round(duration.asHours()) + ' heures ' + duration.minutes() + ' minutes';
        } else {
            return $scope.logs_duration = null;
        }
    });

    const getModulesById = function(id) {
        id = parseInt(id);
        return $scope.modules.find(module => module.id === id);
    };

    if ($location.search().id != null) { $scope.getActivities(getModulesById($location.search().id)); }

    var getModuleDuration = function() {
        const module                 = getModulesById($location.search().id);
        const module_duration        = module.duration * 1000;
        const duration               = moment.duration(module_duration);
        return $scope.module_duration = duration.asHours() + ' heures ' + duration.minutes() + ' minutes';
    };

    $scope.getModuleStatus = function(module) {
        if (((module != null ? module.validation : undefined) != null) && (1 === (module != null ? module.published : undefined))) {
            switch (module.validation) {
                case 'Validée':                 return 'fa fa-check'; break;
                case 'Validée par équivalence': return 'fa fa-check'; break;
                case 'Non validée':             return 'fa fa-times'; break;
            }
        }
        return 'fa fa-clock-o';
    };

    const logsPerUv = () => Log
    .computeLogsPerUvForOneStudent({
        login:   user.login})
    .$promise
    .then(logs => $scope.logs = logs).catch(ErrorHandler);

    logsPerUv();

    $scope.changeTerm = function(term_id) {
        $scope.selected_module = false;
        $location.search({ term_id });
        return Search
        .studentModules({
            role:    'students',
            login:   user.login,
            term_id}).$promise
        .then(function(modules_list) {
            $scope.modules = modules_list;
            return initModulesBySpe();
        });
    };

    $scope.get_activity_status = function(activity) {
        if (null === activity.student_mark) { return ''; }
        if (activity.student_mark >= 10) { return 'Validée'; }
        if (activity.student_mark < 10) { return 'Non validée (moyenne)'; }
    };

    $scope.eliminatory_style = function(activity) {
        if ((activity.eliminate == null) ||
            (-1 === activity.eliminate) ||
            ('Non validée (éliminatoire)' !== $scope.get_activity_status(activity))) { return { }; }

        return { 'color': 'red' };
    };

    initModulesBySpe();
    if ($location.search().term_id != null) {
        return $scope.changeTerm($location.search().term_id);
    } else {
        return $scope.modules = modules;
    }
});

